import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=33734e0f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=33734e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33734e0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33734e0f')) {
      api.createRecord('33734e0f', component.options)
    } else {
      api.reload('33734e0f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=33734e0f&scoped=true&", function () {
      api.rerender('33734e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8VycIScNImOce/JS/comp/SearchFilterTokens.vue"
export default component.exports